namespace GeniuzPOS.Product {
    export interface CsCategoryForm {
        CatCode: Serenity.StringEditor;
        CatName: Serenity.StringEditor;
    }

    export class CsCategoryForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsCategory';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsCategoryForm.init)  {
                CsCategoryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsCategoryForm, [
                    'CatCode', w0,
                    'CatName', w0
                ]);
            }
        }
    }
}
